export class ShowItemSimilarService {
    constructor(httpClient) {
      this.httpClient = httpClient
    }
  
    async handle(params) {
      return await this.httpClient.get('/v01/itens/Similares', { params })
    }
  }
  